import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { Alert } from '../shared/models/Alert';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  observer: Observer<Alert>;
  observable: Observable<Alert>;

  constructor() {
    this.observable = Observable.create(
      (obs: Observer<Alert>) => {
        this.observer = obs;
      }
    );
  }

  ngOnInit() {
  }

  add(alert: Alert) {
    if (this.observer) {
      this.observer.next(alert);
    }
  }

  getAlerts(): Observable<Alert> {
    return this.observable;
  }
}
